module.exports = require("babel-runtime/core-js/array/from");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/array/from"
// module id = 25
// module chunks = 0